import { NextRouter } from "next/router";

export const getCleanPageData = ({ asPath, query }: NextRouter) => {
    // --- Configuration ---
    const queriesToKeep = [
        "_ga","_gl","gclid","utm_id","utm_source","utm_medium","utm_campaign",
        "utm_source_platform","utm_content","utm_term","utm_campaign_id",
        "utm_creative_format","utm_marketing_tactic",
    ];
    const EMAIL_PATTERNS = [/.{4}@.{4}/i, /.{4}%40.{4}/i, /.{4}%2540.{4}/i];

    // --- Get page details ---
    const { protocol, hostname } = window.location;
    let pageTitleClean = document.title;
    let pageClean = asPath.split('?')[0].split('#')[0].toLowerCase();

    // --- Apply cleaning rules ---
    const finalQuery = new URLSearchParams();
    for (const key in query) {
        if (queriesToKeep.includes(key)) {
            const value = Array.isArray(query[key]) ? query[key].join(',') : query[key];
            if (value) finalQuery.set(key, value);
        }
    }
    const containsEmail = (s: string) => EMAIL_PATTERNS.some(rx => rx.test(s));
    if (containsEmail(pageClean)) {
        pageClean = pageClean.split('/').map(segment =>
            containsEmail(segment) ? 'REDACTED_EMAIL' : segment
        ).join('/');
    }
    finalQuery.forEach((value, key) => {
        if (containsEmail(value)) {
            finalQuery.set(key, 'REDACTED_EMAIL');
        }
    });

    // --- Assemble the final clean URL ---
    const hostnameClean = hostname?.toLowerCase().replace('www.', '');
    let finalQueryString = finalQuery?.toString();
    if (finalQueryString) {
        pageClean += `?${finalQueryString}`;
    }
    const pageLocationClean = `${protocol}//${hostnameClean}${pageClean}`;

    return { pageLocationClean, pageTitleClean };
};